import { Box, Card } from '@oresundsbron/bridge-ui';
import { FC, useCallback, useEffect, useRef } from 'react';

export const EmbededReepay: FC<{
  onSuccess: (data: Reepay.Response) => void;
  token?: string;
}> = ({ onSuccess, token }) => {
  const timer = useRef<NodeJS.Timeout>();
  const reepay = useRef<Reepay.EmbeddedCheckout>();

  const initalizeReepay = useCallback(() => {
    if (!window.Reepay || !token || reepay.current) {
      return;
    }

    clearInterval(timer.current as any);
    const { EmbeddedCheckout } = window.Reepay;
    reepay.current = new EmbeddedCheckout(token, {
      html_element: 'rp-container',
      showReceipt: false,
    });
    reepay.current.addEventHandler(Reepay.Event.Accept, (data) => {
      onSuccess(data);
      reepay.current?.destroy();
    });
  }, [token, onSuccess]);

  useEffect(() => {
    return () => {
      if (!reepay.current) {
        return;
      }
      reepay.current.removeEventHandler(Reepay.Event.Accept);
      try {
        reepay.current.destroy();
      } catch {}
    };
  }, []);

  useEffect(() => {
    timer.current = setInterval(initalizeReepay);

    return () => {
      if (!timer.current) {
        return;
      }

      clearInterval(timer.current as any);
    };
  });

  return (
    <Box className="col-span-full flex items-center justify-center md:col-span-6 md:col-start-4">
      <Card.Root id="rp-container" className="h-[600px] w-full sm:w-[500px]" />
    </Box>
  );
};
